import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";

const IconYouTube = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23.495 6.145a3.038 3.038 0 00-2.127-2.14C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.382.505c-1.036.272-1.84 1.09-2.127 2.14C0 8.027 0 11.955 0 11.955s0 3.927.505 5.809a3.037 3.037 0 002.127 2.14C4.5 20.41 12 20.41 12 20.41s7.5 0 9.382-.505c1.036-.272 1.84-1.09 2.127-2.14.491-1.882.491-5.81.491-5.81s0-3.927-.505-5.809zm-13.95 9.382V8.382l6.273 3.572-6.273 3.573z"
  }));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(IconYouTube, _extends({
  svgRef: ref
}, props)));
export default ForwardRef;